<!-- Recent Applications Table -->
<!-- Desktop/Mobile only -->
<div class="tw-hidden md:tw-block tw-pt-[0.7rem]">
    <div
        class="tw-bg-white tw-shadow-sm tw-rounded-[24px] tw-border tw-border-[#6D7A873D]"
    >
        <div class="tw-overflow-x-auto">
            <table class="tw-min-w-full tw-divide-y tw-divide-[#E5E7EB]">
                <thead>
                    <tr>
                        <th
                            class="tw-text-left tw-py-[14px] tw-px-[14px] !tw-text-sm !tw-font-normal !tw-text-[#00000080]"
                        >
                            {{ "COMMON.PRODUCT" | translate }}
                        </th>
                        <th
                            class="tw-py-[14px] tw-px-[14px] !tw-text-sm !tw-font-normal !tw-text-[#00000080]"
                        >
                            {{ "COMMON.FINANCING_AMOUNT" | translate }}
                        </th>
                        <th
                            class="tw-py-[14px] tw-px-[14px] !tw-text-sm !tw-font-normal !tw-text-[#00000080]"
                        >
                            {{ "COMMON.TENURE" | translate }}
                        </th>
                        <th
                            class="tw-py-[14px] tw-px-[14px] !tw-text-sm !tw-font-normal !tw-text-[#00000080] !tw-text-center"
                        >
                            {{ "COMMON.REFERRAL_DATE" | translate }}
                        </th>
                        <th
                            class="tw-py-[14px] tw-px-[14px] !tw-text-sm !tw-font-normal !tw-text-[#00000080]"
                        >
                            {{ "COMMON.STATUS" | translate }}
                        </th>
                        <th
                            class="tw-py-[14px] tw-px-[14px] !tw-text-sm !tw-font-normal !tw-text-[#00000080] !tw-text-center"
                        ></th>
                    </tr>
                </thead>
                <tbody
                    class="tw-text-sm tw-text-[#000000] tw-divide-y tw-divide-[#E5E7EB]"
                >
                    <tr *ngFor="let item of paginatedApplications">
                        <td class="tw-py-4 tw-px-4 tw-w-[280px]">
                            <p
                                class="tw-text-[12px] tw-font-semibold tw-text-[#00000080] tw-mb-1"
                            >
                                {{ "COMMON.RECENT_APPID" | translate }}:
                                {{ item.cCaseAppNo }}
                            </p>
                            <p class="tw-text-[16px] tw-font-semibold">
                                {{ item.productName }}
                            </p>
                        </td>
                        <td
                            class="tw-py-4 tw-px-3 tw-text-[14px] tw-w-[170px] tw-font-normal"
                        >
                            {{
                                item.cCaseFinamt == null
                                    ? "N/A"
                                    : (item.cCaseFinamt
                                      | currency : "RM" : true : "1.0-0")
                            }}
                        </td>
                        <td
                            class="tw-py-4 tw-px-3 tw-text-[14px] tw-font-normal tw-w-[115px]"
                        >
                            <ng-container
                                *ngIf="item.cCasePof !== 'TF' || 'RC'"
                            >
                                {{ item.cCaseTenure }}
                            </ng-container>
                            <span *ngIf="item?.cCasePof == 'TF' || 'RC'">{{
                                item.cCaseTenureUnit
                                    .split("-")
                                    .slice(0, 2)
                                    .join(" - ")
                                    | uppercase
                                    | translate
                            }}</span>
                            <span>&nbsp;</span>
                            <span>{{
                                item.cCaseTenureUnit
                                    .split("-")
                                    .slice(2)
                                    .join("")
                                    | uppercase
                                    | translate
                            }}</span>
                        </td>
                        <td
                            class="tw-py-4 tw-px-3 tw-text-[14px] tw-font-normal tw-text-center tw-min-w-[110px]"
                        >
                            {{ formatDate(item.createdDateTime) }}<br />
                            {{ convertToTimeFormat(item.createdDateTime) }}
                        </td>
                        <td
                            class="tw-py-4 tw-px-4 tw-text-[14px] tw-w-[190px] tw-font-semibold"
                        >
                            {{ item.cCaseStatus | translate }}
                        </td>
                        <td class="tw-py-4 tw-px-4 tw-w-[160px]">
                            <button
                                class="tw-border tw-border-[#003A70] tw-text-[#003A70] tw-text-xs tw-font-semibold tw-rounded-[20px] tw-w-[120px] tw-h-[34px]"
                                (click)="viewAppDetails(item)"
                            >
                                {{ "COMMON.VIEW_DETAILS" | translate }}
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>

<!-- Mobile only -->
<div class="tw-block md:tw-hidden tw-p-4">
    <div
        class="tw-w-full tw-bg-white tw-shadow-lg tw-px-6 tw-py-7 tw-rounded-xl tw-mb-6"
    >
        <!-- No record text -->
        <div
            class="tw-pb-10 tw-mt-8 tw-text-center"
            *ngIf="paginatedApplications.length == 0"
        >
            {{ "DASHBOARD.DASHBOARD_MAIN.NO_APP" | translate }}
        </div>

        <div
            class="tw-flex tw-justify-between tw-font-semibold tw-text-gray-600 tw-mb-4 tw-border-b tw-border-gray-200 tw-pb-3 tw-pr-[70px]"
        >
            <div>{{ "COMMON.PRODUCT" | translate }}</div>
            <div>{{ "COMMON.STATUS" | translate }}</div>
        </div>
        <div
            *ngFor="let item of paginatedApplications"
            class="md:tw-hidden tw-grid tw-grid-cols-2 md:tw-gap-3 tw-text-black"
        >
            <!-- Product & Status Row -->
            <div class="tw-flex tw-col-span-2 tw-gap-6">
                <div class="tw-py-4 tw-flex tw-flex-col tw-gap-1">
                    <span
                        class="tw-text-[12px] md:tw-text-[14px] tw-text-[#00000080]"
                    >
                        {{ "COMMON.RECENT_APPID" | translate }}:
                        {{ item.cCaseAppNo }}
                    </span>
                    <p
                        class="!tw-font-semibold !tw-text-sm md:!tw-text-[16px]"
                        *ngIf="item.productName !== null"
                    >
                        {{ item.productName }}
                    </p>
                </div>
                <div
                    class="tw-py-4 tw-font-semibold tw-text-[12px] md:tw-text-[14px] tw-min-w-[105px]"
                >
                    {{ item.cCaseStatus | translate }}
                </div>
            </div>
            <!-- Financing Amount | Tenure | Referral Date -->
            <div
                class="tw-col-span-2 tw-grid tw-grid-cols-3 tw-gap-4 tw-pt-3 tw-border-b tw-border-gray-200 tw-pb-5"
            >
                <!-- Financing Amount -->
                <div class="tw-flex tw-flex-col">
                    <span class="tw-text-[12px] tw-text-[#00000080]">
                        {{ "COMMON.FINANCING_AMOUNT" | translate }}
                    </span>
                    <span class="tw-text-sm tw-font-medium">
                        {{
                            item.cCaseFinamt == null
                                ? "N/A"
                                : (item.cCaseFinamt
                                  | currency : "RM" : true : "1.0-0")
                        }}
                    </span>
                </div>

                <!-- Tenure -->
                <div class="tw-flex tw-flex-col">
                    <span class="tw-text-[12px] tw-text-[#00000080]">
                        {{ "COMMON.TENURE" | translate }}
                    </span>
                    <span class="tw-text-sm tw-font-medium">
                        <ng-container *ngIf="item.cCasePof !== 'TF' || 'RC'">
                            {{ item.cCaseTenure }}
                        </ng-container>
                        <span *ngIf="item.cCasePof == 'TF' || 'RC'">
                            {{
                                item.cCaseTenureUnit
                                    .split("-")
                                    .slice(0, 2)
                                    .join(" - ")
                                    | uppercase
                                    | translate
                            }}
                        </span>
                        <span>
                            {{
                                item.cCaseTenureUnit
                                    .split("-")
                                    .slice(2)
                                    .join("")
                                    | uppercase
                                    | translate
                            }}
                        </span>
                    </span>
                </div>

                <!-- Referral Date -->
                <div class="tw-flex tw-flex-col">
                    <span class="tw-text-[12px] tw-text-[#00000080]">
                        {{ "COMMON.REFERRAL_DATE" | translate }}
                    </span>
                    <span class="tw-text-sm tw-font-medium">
                        {{ formatDate(item.createdDateTime) }}<br />
                        {{ convertToTimeFormat(item.createdDateTime) }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>
